import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';

import { register as registerSwiperElements } from 'swiper/element/bundle';
import { CookieService } from 'ngx-cookie-service';
import { appConfig } from './app/app.config';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LottieComponent as NgxLottieComponent } from 'ngx-lottie';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  registerSwiperElements();
  bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(FormsModule, MatSelectModule, ReactiveFormsModule, CommonModule, AppRoutingModule, MatSidenavModule, MatToolbarModule, MatButtonModule, MatMenuModule, MatIconModule, MatExpansionModule, MatListModule, MatInputModule, MatChipsModule, MatStepperModule, MatCheckboxModule, MatDialogModule, MatSnackBarModule, BrowserModule.withServerTransition({ appId: 'serverApp' })),
        CookieService,
        ...appConfig.providers,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ],
})
  .catch(err => console.error(err));
};


 if (document.readyState === 'complete') {
   bootstrap();
 } else {
   document.addEventListener('DOMContentLoaded', bootstrap);
 }

